<template>
  <div class="collegeCulture-page">
    <div class="cross" v-if="screenType == 0"></div>
    <div v-else class="vertical">
      <van-grid :column-num="3" :gutter="15">
        <van-grid-item v-for="value in list" :key="value">
          <template #icon>
            <div class="defaultContent">
              <van-image
                class="img"
                :src="require('../../../../assets/themes/img/teasLogin/bg.jpg')"
                @click="clickImg"
              />
              <div class="title">{{ "校工会兴趣小组活动" }}</div>
            </div>
          </template>
        </van-grid-item>
      </van-grid>
    </div>
    <van-image-preview class="preview" v-model="show" :images="[showimg]" :closeable="true" get-container="#app">
    </van-image-preview>
  </div>
</template>

<script>
export default {
  name: "collegeCulture",
  data() {
    return {
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      screenType: 0, //屏幕类型：0为横向，1为纵向
      show: false,
      showimg: "",
    };
  },
  created() {
    this.screenType = this.$route.meta.screenType;
    this.getData();
  },
  methods: {
    getData() {
      // this.$http
      //   .get(this.url, {
      //     pageSize: this.maxTags,
      //   })
      //   .then(({ data }) => {
      //     if (data && data.success) {
      //       this.swiperList = data.data;
      //     }
      //   })
      //   .catch(() => {
      //     this.swiperList = [];
      //   });
    },
    clickImg(item) {
      this.show = true;
      this.showimg = "https://img01.yzcdn.cn/vant/apple-1.jpg";
    },
  },
};
</script>

<style>
</style>